<template>
	<div class="assets-wrapper">
		<portfolio-buttons />
		<div class="card mt-1">
			<div class="card-header">{{chartPage === 2 && isPolaris ? 'Polaris Finance' : 'Vývoj majetku'}}</div>
			<div class="card-body chart-area pt-2 pb-1">
				<assets-trend-graph v-if="chartPage === 1" />
				<assets-composition-full v-if="chartPage === 2 && !isPolaris"/>
                <polaris-composition-full v-if="chartPage === 2 && isPolaris"/>
				<div class="text-center mb-1">
					<paginator :pages="2" :page="chartPage" @changed="chartPage = $event" />
				</div>
			</div>
		</div>
		<div class="card mt-4">
			<div class="card-header">Majetok</div>
			<div class="card-body p-0">
                <Loading v-if="loadingList" class="my-5"/>
				<data-grid :items="list" :columns="columns" :on-detail-open="loadDetail" v-else>
					<template slot="pl" slot-scope="{ item }">
						<profit v-if="item.code" :value="parseFloat(item.pl)" />
					</template>
					<template slot="originalSum" slot-scope="{ item }">
						{{ item.originalSum | number }}
					</template>
					<template slot="sumEUR" slot-scope="{ item }">
						{{ item.sumEUR | number }}
					</template>
					<template slot="price" slot-scope="{ item }">
                        <span v-if="item.code">{{ item.price | number }}</span>
                        <span v-else></span>
					</template>
					<template  slot="count" slot-scope="{ item }">
                        <span v-if="item.code">{{ item.count | number(null) }}</span>
						<span v-else></span>
					</template>
					<template slot="detail" slot-scope="{ item }">
                        <Loading v-if="!item.detail && detailPage === 1" class="mb-5 p-5"/>
						<div v-if="item.detail && detailPage === 1" class="row mt-md-2">
							<div class="col-12 col-md-7 order-md-2">
								<asset-value-graph :points="item.detail.graph" />
							</div>
							<div class="col-12 col-md-5 pt-md-3 order-md-1">
								<strong>Podrobnosti</strong>
								<div class="details-wrapper">
									<div class="row">
										<div class="col-md-4">Emitent:</div>
										<div class="col-md-8">{{ item.detail.detail.emitent }}</div>
									</div>
									<div class="row">
										<div class="col-md-4">Zisk/strata v %:</div>
										<div class="col-md-8"><profit :value="item.detail.detail.profitLossPercentage" :color="false" /></div>
									</div>
									<div class="row">
										<div class="col-md-4">Zisk/strata:</div>
										<div class="col-md-8">{{ item.detail.detail.profitLossCoupon | number }} {{ item.currency }}</div>
									</div>
									<div class="row">
										<div class="col-md-4">Vstupná cena:</div>
										<div class="col-md-8">{{ item.detail.detail.buyingPrice | number }} {{ item.currency }}</div>
									</div>
									<div class="row">
										<div class="col-md-4">Krajina:</div>
										<div class="col-md-8">{{ item.detail.detail.country }}</div>
									</div>
									<div class="row mt-4">
										<div class="col-12">
											<button type="button" class="btn btn-outline-primary text-uppercase mr-5" @click="showModal(item.code,true)">
												Predaj
											</button>
											<button type="button" class="btn btn-primary text-uppercase" @click="showModal(item.code,false)">
												Nákup
											</button>
										</div>
                                        <Request ref="request" type="trade" :requestInfo="tradeRequest"/>
									</div>
								</div>
							</div>
						</div>
                        <Loading v-if="!item.transactions && detailPage === 2" class="mb-5 p-5"/>
                        <div v-if="item.transactions && detailPage === 2" class="row ml-0 mt-md-2">
							<data-grid class="no-style" :items="item.transactions" :columns="transactionsColumns" :show-detail="false">
								<template slot="date" slot-scope="{ item }">
									{{ item.date | date }}
								</template>
								<template slot="price" slot-scope="{ item }">
									{{ item.price | number(2) }}
								</template>
								<template slot="volume" slot-scope="{ item }">
									{{ item.volume | number(2) }}
								</template>
							</data-grid>
						</div>
						<div class="text-center mb-1">
							<paginator :pages="2" :page="detailPage" @changed="detailPage = $event" />
						</div>
					</template>
				</data-grid>
			</div>
		</div>
	</div>
</template>

<script>
import PortfolioButtons from "../../../components/PortfolioButtons";
import AssetsTrendGraph from "../../../components/AssetsTrendGraph";
import DataGrid from "../../../components/DataGrid";
import Profit from "../../../components/profit";
import AssetValueGraph from "../../../components/AssetValueGraph";
import Paginator from "../../../components/Paginator";
import AssetsCompositionFull from "./AssetsCompositionFull";
import PolarisCompositionFull from "./PolarisCompositionFull";
import Loading from "../../../components/Loading";
import Request from "../../../components/Request";

export default {
	name: "Assets",
	components: {
		AssetsCompositionFull,
		Paginator,
		AssetValueGraph,
		Profit,
		DataGrid,
		AssetsTrendGraph,
		PortfolioButtons,
        Loading,
        Request,
        PolarisCompositionFull
    },
	computed: {
		portfolio() {
			return this.$store.state.portfolio.selected;
		},
		isPolaris() {
			if (this.portfolio) {
				if (this.portfolio.description.includes('Polaris')) {
				return true;
				}
			}
			return false;
		},
		list() {
			return this.$store.state.assets.list;
		},
		loadingList() {
			return this.$store.state.assets.loadingList;
		},
		loadingDetail() {
			return this.$store.state.assets.loadingDetail;
		},
		loadingTransactions() {
			return this.$store.state.assets.loadingTransactions;
		},
		loading() {
			return this.$store.state.assets.loading;
		},
	},
	watch: {
		portfolio() {
			this.loadData();
		},
	},
	mounted() {
		this.loadData();
	},
	methods: {
		loadData() {
			this.$store.dispatch("assets/loadList", this.portfolio);
		},
		loadDetail(asset, index) {
            this.detailPage = 1;
			this.$store.dispatch("assets/assetDetail", { code: asset.code, index });
			this.$store.dispatch("assets/assetTransactions", { code: asset.code, index, portfolio: this.portfolio });
		},
		showModal(code, isSale) {
			this.tradeRequest.isSale = isSale;
			this.tradeRequest.code = code;
			this.$refs.request.show();
		},
	},
	data() {
		return {
			chartPage: 1,
            detailPage: 1,
			columns: [
				{
					name: "Aktívum",
					slug: "asset",
				},
				{
					name: "ISIN",
					slug: "isin",
				},
				{
					name: "Typ",
					slug: "type",
				},
				{
					name: "Počet",
					slug: "count",
				},
				{
					name: "Cena",
					slug: "price",
				},
				{
					name: "Mena",
					slug: "originalCurrency",
				},
				{
					name: "Objem",
					slug: "originalSum",
				},
				{
					name: "Objem v ref. mene",
					slug: "sumEUR",
				},
				{
					name: "P/L",
					slug: "pl",
				},
			],
			transactionsColumns: [
				{
					name: 'História',
					slug: 'date'
				},
				{
					name: 'Popis',
					slug: 'description'
				},
				{
					name: 'Počet',
					slug: 'count'
				},
				{
					name: 'Cena',
					slug: 'price'
				},
				{
					name: 'Mena',
					slug: 'currency'
				},
				{
					name: 'Objem',
					slug: 'volume'
				}
			],
			tradeRequest: {
				isSale: true,
				code: ''
			}
		};
	},
};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.assets-wrapper {
	.chart-area {
		min-height: 383px;

		@include media-breakpoint-down(sm) {
			padding-left: 0;
			padding-right: 0;
		}
	}

    .table th {
        padding-right: 10px !important;
        padding-left: 10px !important;
    }
}
</style>
